import App from './App';
import './i18n';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
} from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { UserProvider } from '@/context/userContext';
import NavigationDrawer from './common/components/NavigationDrawer';
import NavigateWithState from './common/components/NavigateWithState';
import Page404 from './pages/404';
import ErrorPage from './pages/error-page';
import ErrorBoundary from './ErrorBoundary';
import RequireAuth from './pages/auth/RequireAuth';
import LoginPage from './pages/auth/LoginPage';
import PreAdmissionProgressSummaryPage from './pages/pre-admission/pre-admission-container/PreAdmissionProgressSummaryPage';
import { PreAdmissionTab } from './api/enum/common.enum';
import PreAdmissionCreatePage from './pages/pre-admission/pre-admission/PreAdmissionCreatePage';
import PreAdmissionDetailPage from './pages/pre-admission/pre-admission/PreAdmissionDetailPage';
import EditPreAdmissionDetailsPage from './pages/pre-admission/pre-admission/EditPreAdmissionDetailsPage';
import EditClientInformationPage from './pages/pre-admission/pre-admission/EditClientInformationPage';
import EditReferrerInformationPage from './pages/pre-admission/pre-admission/EditReferrerInformationPage';
import EditCaseStatusPage from './pages/pre-admission/pre-admission/EditCaseStatusPage';
import EditResultsPage from './pages/pre-admission/pre-admission/EditResultsPage';
import FormsManagementPage from './pages/pre-admission/forms-management/FormsManagementPage';
import CreateEnquiryRecordPage from './pages/pre-admission/forms-management/enquiryRecord/CreateEnquiryRecordPage';
import EditEnquiryRecordPage from './pages/pre-admission/forms-management/enquiryRecord/EditEnquiryRecordPage';
import EnquiryRecordDetailPage from './pages/pre-admission/forms-management/enquiryRecord/EnquiryRecordDetailPage';
import CreateFaceSheetPage from './pages/pre-admission/forms-management/faceSheet/CreateFaceSheetPage';
import EditFaceSheetPage from './pages/pre-admission/forms-management/faceSheet/EditFaceSheetPage';
import FaceSheetDetailPage from './pages/pre-admission/forms-management/faceSheet/FaceSheetDetailPage';
import CreateAppendix4Page from './pages/pre-admission/forms-management/appendix4/CreateAppendix4Page';
import EditAppendix4Page from './pages/pre-admission/forms-management/appendix4/EditAppendix4Page';
import Appendix4DetailPage from './pages/pre-admission/forms-management/appendix4/Appendix4DetailPage';
import CreateAppendix5Page from './pages/pre-admission/forms-management/appendix5/CreateAppendix5Page';
import EditAppendix5Page from './pages/pre-admission/forms-management/appendix5/EditAppendix5Page';
import Appendix5DetailPage from './pages/pre-admission/forms-management/appendix5/Appendix5DetailPage';
import CreateAppendix6Page from './pages/pre-admission/forms-management/appendix6/CreateAppendix6Page';
import EditAppendix6Page from './pages/pre-admission/forms-management/appendix6/EditAppendix6Page';
import Appendix6DetailPage from './pages/pre-admission/forms-management/appendix6/Appendix6DetailPage';
import CreateAppendix7Page from './pages/pre-admission/forms-management/appendix7/CreateAppendix7Page';
import EditAppendix7Page from './pages/pre-admission/forms-management/appendix7/EditAppendix7Page';
import Appendix7DetailPage from './pages/pre-admission/forms-management/appendix7/Appendix7DetailPage';
import CreateMemberApplicationPage from './pages/pre-admission/forms-management/memberApplication/CreateMemberApplicationPage';
import EditMemberApplicationPage from './pages/pre-admission/forms-management/memberApplication/EditMemberApplicationPage';
import MemberApplicationDetailPage from './pages/pre-admission/forms-management/memberApplication/MemberApplicationDetailPage';
import NewConsentDetailPage from './pages/pre-admission/forms-management/newConsent/NewConsentDetailPage';
import EditNewConsentPage from './pages/pre-admission/forms-management/newConsent/EditNewConsentPage';
import CreateNewConsentPage from './pages/pre-admission/forms-management/newConsent/CreateNewConsentPage';
import CreateStopServicePage from './pages/pre-admission/forms-management/stopService/CreateStopServicePage';
import EditStopServicePage from './pages/pre-admission/forms-management/stopService/EditStopServicePage';
import StopServiceDetailPage from './pages/pre-admission/forms-management/stopService/StopServiceDetailPage';
import CreateWellBeingScalePage from './pages/pre-admission/forms-management/wellBeingScale/CreateWellBeingScalePage';
import EditWellBeingScalePage from './pages/pre-admission/forms-management/wellBeingScale/EditWellBeingScalePage';
import WellBeingScaleDetailPage from './pages/pre-admission/forms-management/wellBeingScale/WellBeingScaleDetailPage';
import CreateRecoveryAssessmentScalePage from './pages/pre-admission/forms-management/recoveryAssessmentScale/CreateRecoveryAssessmentScalePage';
import EditRecoveryAssessmentScalePage from './pages/pre-admission/forms-management/recoveryAssessmentScale/EditRecoveryAssessmentScalePage';
import RecoveryAssessmentScaleDetailPage from './pages/pre-admission/forms-management/recoveryAssessmentScale/RecoveryAssessmentScaleDetailPage';
import CreateDsm5AdultPage from './pages/pre-admission/forms-management/dsm5Adult/CreateDsm5AdultPage';
import EditDsm5AdultPage from './pages/pre-admission/forms-management/dsm5Adult/EditDsm5AdultPage';
import Dsm5AdultDetailPage from './pages/pre-admission/forms-management/dsm5Adult/Dsm5AdultDetailPage';
import CreateDsm5TeenPage from './pages/pre-admission/forms-management/dsm5Teen/CreateDsm5TeenPage';
import EditDsm5TeenPage from './pages/pre-admission/forms-management/dsm5Teen/EditDsm5TeenPage';
import Dsm5TeenDetailPage from './pages/pre-admission/forms-management/dsm5Teen/Dsm5TeenDetailPage';
import UserManagementSummaryPage from './pages/user-management/user-management-summary/UserManagementSummaryPage';
import UserCreatePage from './pages/user-management/user-management-summary/UserCreatePage';
import UserDetailPage from './pages/user-management/user-management-summary/UserDetailPage';
import UserEditPage from './pages/user-management/user-management-summary/UserEditPage';
import AdmissionRequestAllSummaryPage from './pages/member-management/admission-request-all/AdmissionRequestAllSummaryPage';
import AdmissionRequestNotSummaryPage from './pages/member-management/admission-request-not/AdmissionRequestNotSummaryPage';
import AdmissionRequestDetail from './pages/member-management/admission-request-detail/AdmissionRequestDetail';
import EditPersonalInformation from './pages/member-management/member-info-edit/EditPersonalInformation';
import EditContactInformation from './pages/member-management/member-info-edit/EditContactInformation';
import EditFamilyInformation from './pages/member-management/member-info-edit/EditFamilyInformation';
import EditWorkInformation from './pages/member-management/member-info-edit/EditWorkInformation';
import EditMembershipInformation from './pages/member-management/member-info-edit/EditMembershipInformation';
import EditCaseStatusInformation from './pages/member-management/member-info-edit/EditCaseStatusInformation';
import EditReferrerInformation from './pages/member-management/member-info-edit/EditReferrerInformation';
import EditShareInformation from './pages/member-management/member-info-edit/EditShareInformation';
import EditHealthInformation from './pages/member-management/member-info-edit/EditHealthInformation';
import PendingSubmissionSummaryPage from './pages/member-management/pending-submission-list/PendingSubmissionSummaryPage';
import CentrePendingSubmissionSummaryPage from './pages/member-management/centre-pending-submission-list/CentrePendingSubmissionSummaryPage';
import AwaitingSummaryPage from './pages/member-management/awaiting-list/AwaitingSummaryPage';
import CentreAwaitingSummaryPage from './pages/member-management/centre-awaiting-list/CentreAwaitingSummaryPage';
import PendingIntakeSummaryPage from './pages/member-management/pending-intake-list/PendingIntakeSummaryPage';
import CentrePendingIntakeSummaryPage from './pages/member-management/centre-pending-intake-list/CentrePendingIntakeSummaryPage';
import MemberAllSummaryPage from './pages/member-management/member-all/MemberAllSummaryPage';
import MemberCaseSummaryPage from './pages/member-management/member-case/MemberCaseSummaryPage';
import MemberProgramSummaryPage from './pages/member-management/member-program/MemberProgramSummaryPage';
import MemberNoServiceSummaryPage from './pages/member-management/member-no-service/MemberNoServiceSummaryPage';
import CaseAllSummaryPage from './pages/case-management/case-all/CaseAllSummaryPage';
import CasePendingSummaryPage from './pages/case-management/case-pending/CasePendingSummaryPage';
import CaseRelievingSummaryPage from './pages/case-management/case-relieving/CaseRelievingSummaryPage';
import CaseSharedSummaryPage from './pages/case-management/case-shared/CaseSharedSummaryPage';
import CentreAdmittedSummaryPage from './pages/case-management/centre-admitted/CentreAdmittedSummaryPage';
import CentreNotAdmittedSummaryPage from './pages/case-management/centre-not-admitted/CentreNotAdmittedSummaryPage';
import CentreCloseSummaryPage from './pages/case-management/centre-close/CentreCloseSummaryPage';
import ProgramAllSummaryPage from './pages/case-management/program-all/ProgramAllSummaryPage';
import ProgramPendingSummaryPage from './pages/case-management/program-pending/ProgramPendingSummaryPage';
import ProgramStaffSummaryPage from './pages/case-management/program-staff/ProgramStaffSummaryPage';
import CentreProgramSummaryPage from './pages/case-management/centre-program-admitted/CentreProgramSummaryPage';
import CentreProgramNotSummaryPage from './pages/case-management/centre-program-not/CentreProgramNotSummaryPage';
import InterventionWorkerSummaryPage from './pages/case-management/intervention-worker/InterventionWorkerSummaryPage';
import InterventionSubmitterSummaryPage from './pages/case-management/intervention-submitter/InterventionSubmitterSummaryPage';
import CentreInterventionSummaryPage from './pages/case-management/centre-intervention/CentreInterventionSummaryPage';
import InterventionDetailPage from './pages/case-management/centre-intervention/InterventionDetailPage';
import EditCentreInterventionPage from './pages/case-management/centre-intervention/EditCentreInterventionPage';
import CreateCentreInterventionPage from './pages/case-management/centre-intervention/CreateCentreInterventionPage';
import EditCaseNotePage from './pages/case-management/centre-intervention/EditCaseNotePage';
import FamilyManagementSummaryPage from './pages/family-management/family-management-summary/FamilyManagementSummaryPage';
import FamilyCreatePage from './pages/family-management/family-management-summary/FamilyCreatePage';
import FamilyDetailPage from './pages/family-management/family-management-summary/FamilyDetailPage';
import FamilyToCreatePage from './pages/family-management/family-management-summary/FamilyToCreatePage';
import FamilyEditServiceDetailsPage from './pages/family-management/family-management-summary/FamilyEditServiceDetailsPage';
import FamilyEditPersonalPage from './pages/family-management/family-management-summary/FamilyEditPersonalPage';
import FamilyEditEducationPage from './pages/family-management/family-management-summary/FamilyEditEducationPage';
import FamilyEditRecoveryPage from './pages/family-management/family-management-summary/FamilyEditRecoveryPage';
import FamilyEditInterestsPage from './pages/family-management/family-management-summary/FamilyEditInterestsPage';
import FamilyEditRemarksPage from './pages/family-management/family-management-summary/FamilyEditRemarksPage';
import EditLoginIdPage from './common/components/program-app-login/EditLoginIdPage';
import ProgramAppSettingsPage from './common/components/program-app-login/ProgramAppSettingsPage';
import FamilyFormsManagementPage from './pages/family-management/family-forms-management/FamilyFormsManagementPage';
import FieldManagementSummaryPage from './pages/field-management/field-management-summary/FieldManagementSummaryPage';
import ReportSummaryPage from './pages/report-summary/ReportSummaryPage';
import UnitSummaryPage from './pages/field-management/unit-summary/UnitSummaryPage';
import UnitStatusPage from './pages/field-management/unit-summary/UnitStatusPage';
import UnitOrderPage from './pages/field-management/unit-summary/UnitOrderPage';
import RegionOrderPage from './pages/field-management/region-summary/RegionOrderPage';
import RegionSummaryPage from './pages/field-management/region-summary/RegionSummaryPage';
import RegionStatusPage from './pages/field-management/region-summary/RegionStatusPage';
import FieldCommonSummaryPage from './pages/field-management/field-common-summary/FieldCommonSummaryPage';
import FieldCommonStatusPage from './pages/field-management/field-common-summary/FieldCommonStatusPage';
import FieldCommonOrderPage from './pages/field-management/field-common-summary/FieldCommonOrderPage';
import FamilyDetailZhPage from './pages/family-management/family-forms-management/FamilyDetailZhPage';
import NotificationSummaryPage from './pages/notification/NotificationSummaryPage';
import NotificationDetailPage from './pages/notification/NotificationDetailPage';

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path='error-page' element={<ErrorPage />} />
			<Route
				path=''
				element={
					<ErrorBoundary>
						<App />
					</ErrorBoundary>
				}
			>
				<Route path='*' element={<Page404 />} />
				<Route path='login' element={<Outlet />}>
					<Route index element={<LoginPage />} />
				</Route>
				<Route element={<RequireAuth></RequireAuth>}>
					<Route path='app'>
						<Route index element={<NavigateWithState to='vouchers' />} />
					</Route>
					<Route
						path=''
						element={
							<UserProvider>
								<NavigationDrawer />
							</UserProvider>
						}
					>
						<Route path='pre-admission'>
							<Route path='pre-admission-list'>
								<Route
									index
									element={
										<PreAdmissionProgressSummaryPage
											preAdmissionTab={PreAdmissionTab.progress}
										/>
									}
								></Route>
								<Route path='submitted'>
									<Route
										index
										element={
											<PreAdmissionProgressSummaryPage
												preAdmissionTab={PreAdmissionTab.submitted}
											/>
										}
									/>
								</Route>
								<Route path='not-suitable'>
									<Route
										index
										element={
											<PreAdmissionProgressSummaryPage
												preAdmissionTab={PreAdmissionTab.notSuitable}
											/>
										}
									/>
								</Route>
								<Route path='all'>
									<Route
										index
										element={
											<PreAdmissionProgressSummaryPage
												preAdmissionTab={PreAdmissionTab.all}
											/>
										}
									/>
								</Route>

								<Route path='create' element={<PreAdmissionCreatePage />} />
								<Route path='detail/:preAdmissionId'>
									<Route index element={<PreAdmissionDetailPage />} />
									<Route
										path='edit-pre-admission'
										element={<EditPreAdmissionDetailsPage />}
									/>
									<Route
										path='edit-client-information'
										element={<EditClientInformationPage />}
									/>
									<Route
										path='edit-referrer-information'
										element={<EditReferrerInformationPage />}
									/>
									<Route
										path='edit-case-status'
										element={<EditCaseStatusPage />}
									/>
									<Route path='edit-results' element={<EditResultsPage />} />
									<Route path='forms-management'>
										<Route index element={<FormsManagementPage />} />
										<Route
											path='create-enquiry-record/:formType'
											element={<CreateEnquiryRecordPage />}
										/>
										<Route
											path='edit-enquiry-record/:enquiryRecordId'
											element={<EditEnquiryRecordPage />}
										/>
										<Route
											path='detail-enquiry-record/:enquiryRecordId'
											element={<EnquiryRecordDetailPage />}
										/>
										<Route
											path='create-face-sheet/:formType'
											element={<CreateFaceSheetPage />}
										/>
										<Route
											path='edit-face-sheet/:faceSheetId'
											element={<EditFaceSheetPage />}
										/>
										<Route
											path='detail-face-sheet/:faceSheetId'
											element={<FaceSheetDetailPage />}
										/>
										<Route
											path='create-appendix4/:formType'
											element={<CreateAppendix4Page />}
										/>
										<Route
											path='edit-appendix4/:appendix4Id'
											element={<EditAppendix4Page />}
										/>
										<Route
											path='detail-appendix4/:appendix4Id'
											element={<Appendix4DetailPage />}
										/>
										<Route
											path='create-appendix5/:formType'
											element={<CreateAppendix5Page />}
										/>
										<Route
											path='edit-appendix5/:appendix5Id'
											element={<EditAppendix5Page />}
										/>
										<Route
											path='detail-appendix5/:appendix5Id'
											element={<Appendix5DetailPage />}
										/>
										<Route
											path='create-appendix6/:formType'
											element={<CreateAppendix6Page />}
										/>
										<Route
											path='edit-appendix6/:appendix6Id'
											element={<EditAppendix6Page />}
										/>
										<Route
											path='detail-appendix6/:appendix6Id'
											element={<Appendix6DetailPage />}
										/>
										<Route
											path='create-appendix7/:formType'
											element={<CreateAppendix7Page />}
										/>
										<Route
											path='edit-appendix7/:appendix7Id'
											element={<EditAppendix7Page />}
										/>
										<Route
											path='detail-appendix7/:appendix7Id'
											element={<Appendix7DetailPage />}
										/>
										<Route
											path='create-member-application/:formType'
											element={<CreateMemberApplicationPage />}
										/>
										<Route
											path='edit-member-application/:memberApplicationId'
											element={<EditMemberApplicationPage />}
										/>
										<Route
											path='detail-member-application/:memberApplicationId'
											element={<MemberApplicationDetailPage />}
										/>
										<Route
											path='create-new-consent/:formType'
											element={<CreateNewConsentPage />}
										/>
										<Route
											path='edit-new-consent/:newConsentId'
											element={<EditNewConsentPage />}
										/>
										<Route
											path='detail-new-consent/:newConsentId'
											element={<NewConsentDetailPage />}
										/>
										<Route
											path='create-stop-service/:formType'
											element={<CreateStopServicePage />}
										/>
										<Route
											path='edit-stop-service/:stopServiceId'
											element={<EditStopServicePage />}
										/>
										<Route
											path='detail-stop-service/:stopServiceId'
											element={<StopServiceDetailPage />}
										/>
										<Route
											path='create-well-being-scale/:formType'
											element={<CreateWellBeingScalePage />}
										/>
										<Route
											path='edit-well-being-scale/:wellBeingScaleId'
											element={<EditWellBeingScalePage />}
										/>
										<Route
											path='detail-well-being-scale/:wellBeingScaleId'
											element={<WellBeingScaleDetailPage />}
										/>
										<Route
											path='create-recovery-assessment-scale/:formType'
											element={<CreateRecoveryAssessmentScalePage />}
										/>
										<Route
											path='edit-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<EditRecoveryAssessmentScalePage />}
										/>
										<Route
											path='detail-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<RecoveryAssessmentScaleDetailPage />}
										/>
										<Route
											path='create-dsm5-adult/:formType'
											element={<CreateDsm5AdultPage />}
										/>
										<Route
											path='edit-dsm5-adult/:dsm5AdultId'
											element={<EditDsm5AdultPage />}
										/>
										<Route
											path='detail-dsm5-adult/:dsm5AdultId'
											element={<Dsm5AdultDetailPage />}
										/>
										<Route
											path='create-dsm5-teen/:formType'
											element={<CreateDsm5TeenPage />}
										/>
										<Route
											path='edit-dsm5-teen/:dsm5TeenId'
											element={<EditDsm5TeenPage />}
										/>
										<Route
											path='detail-dsm5-teen/:dsm5TeenId'
											element={<Dsm5TeenDetailPage />}
										/>
									</Route>
								</Route>
							</Route>
						</Route>
						<Route path='user-management'>
							<Route path='user-management-list'>
								<Route index element={<UserManagementSummaryPage />}></Route>
								<Route path='create' element={<UserCreatePage />} />
								<Route path='detail/:userId' element={<UserDetailPage />} />
								<Route path='edit/:userId' element={<UserEditPage />} />
							</Route>
						</Route>
						<Route path='member-management'>
							<Route path='member-list'>
								<Route index element={<MemberAllSummaryPage />} />
								<Route path='case' element={<MemberCaseSummaryPage />} />
								<Route path='program' element={<MemberProgramSummaryPage />} />
								<Route
									path='noService'
									element={<MemberNoServiceSummaryPage />}
								/>
								<Route path='detail/:admissionRequestId'>
									<Route
										index
										element={<AdmissionRequestDetail type='member' />}
									/>
									<Route
										path='create/:myCaseId/:interventionPage'
										element={<CreateCentreInterventionPage />}
									/>
									<Route
										path='personal'
										element={<EditPersonalInformation type='member' />}
									/>
									<Route
										path='contact'
										element={<EditContactInformation type='member' />}
									/>
									<Route
										path='family'
										element={<EditFamilyInformation type='member' />}
									/>
									<Route
										path='work'
										element={<EditWorkInformation type='member' />}
									/>
									<Route
										path='membership'
										element={<EditMembershipInformation type='member' />}
									/>
									<Route
										path='case'
										element={<EditCaseStatusInformation type='member' />}
									/>
									<Route
										path='referrer'
										element={<EditReferrerInformation type='member' />}
									/>
									<Route
										path='share'
										element={<EditShareInformation type='member' />}
									/>
									<Route
										path='health'
										element={<EditHealthInformation type='member' />}
									/>
									<Route
										path='login-id'
										element={<EditLoginIdPage entity='member' />}
									/>
									<Route
										path='edit-program-app-settings'
										element={<ProgramAppSettingsPage entity='member' />}
									/>
									<Route path='forms-management'>
										<Route index element={<FormsManagementPage />} />
										<Route
											path='create-enquiry-record/:formType'
											element={<CreateEnquiryRecordPage />}
										/>
										<Route
											path='edit-enquiry-record/:enquiryRecordId'
											element={<EditEnquiryRecordPage />}
										/>
										<Route
											path='detail-enquiry-record/:enquiryRecordId'
											element={<EnquiryRecordDetailPage />}
										/>
										<Route
											path='create-face-sheet/:formType'
											element={<CreateFaceSheetPage />}
										/>
										<Route
											path='edit-face-sheet/:faceSheetId'
											element={<EditFaceSheetPage />}
										/>
										<Route
											path='detail-face-sheet/:faceSheetId'
											element={<FaceSheetDetailPage />}
										/>
										<Route
											path='create-appendix4/:formType'
											element={<CreateAppendix4Page />}
										/>
										<Route
											path='edit-appendix4/:appendix4Id'
											element={<EditAppendix4Page />}
										/>
										<Route
											path='detail-appendix4/:appendix4Id'
											element={<Appendix4DetailPage />}
										/>
										<Route
											path='create-appendix5/:formType'
											element={<CreateAppendix5Page />}
										/>
										<Route
											path='edit-appendix5/:appendix5Id'
											element={<EditAppendix5Page />}
										/>
										<Route
											path='detail-appendix5/:appendix5Id'
											element={<Appendix5DetailPage />}
										/>
										<Route
											path='create-appendix6/:formType'
											element={<CreateAppendix6Page />}
										/>
										<Route
											path='edit-appendix6/:appendix6Id'
											element={<EditAppendix6Page />}
										/>
										<Route
											path='detail-appendix6/:appendix6Id'
											element={<Appendix6DetailPage />}
										/>
										<Route
											path='create-appendix7/:formType'
											element={<CreateAppendix7Page />}
										/>
										<Route
											path='edit-appendix7/:appendix7Id'
											element={<EditAppendix7Page />}
										/>
										<Route
											path='detail-appendix7/:appendix7Id'
											element={<Appendix7DetailPage />}
										/>
										<Route
											path='create-member-application/:formType'
											element={<CreateMemberApplicationPage />}
										/>
										<Route
											path='edit-member-application/:memberApplicationId'
											element={<EditMemberApplicationPage />}
										/>
										<Route
											path='detail-member-application/:memberApplicationId'
											element={<MemberApplicationDetailPage />}
										/>
										<Route
											path='create-new-consent/:formType'
											element={<CreateNewConsentPage />}
										/>
										<Route
											path='edit-new-consent/:newConsentId'
											element={<EditNewConsentPage />}
										/>
										<Route
											path='detail-new-consent/:newConsentId'
											element={<NewConsentDetailPage />}
										/>
										<Route
											path='create-stop-service/:formType'
											element={<CreateStopServicePage />}
										/>
										<Route
											path='edit-stop-service/:stopServiceId'
											element={<EditStopServicePage />}
										/>
										<Route
											path='detail-stop-service/:stopServiceId'
											element={<StopServiceDetailPage />}
										/>
										<Route
											path='create-well-being-scale/:formType'
											element={<CreateWellBeingScalePage />}
										/>
										<Route
											path='edit-well-being-scale/:wellBeingScaleId'
											element={<EditWellBeingScalePage />}
										/>
										<Route
											path='detail-well-being-scale/:wellBeingScaleId'
											element={<WellBeingScaleDetailPage />}
										/>
										<Route
											path='create-recovery-assessment-scale/:formType'
											element={<CreateRecoveryAssessmentScalePage />}
										/>
										<Route
											path='edit-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<EditRecoveryAssessmentScalePage />}
										/>
										<Route
											path='detail-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<RecoveryAssessmentScaleDetailPage />}
										/>
										<Route
											path='create-dsm5-adult/:formType'
											element={<CreateDsm5AdultPage />}
										/>
										<Route
											path='edit-dsm5-adult/:dsm5AdultId'
											element={<EditDsm5AdultPage />}
										/>
										<Route
											path='detail-dsm5-adult/:dsm5AdultId'
											element={<Dsm5AdultDetailPage />}
										/>
										<Route
											path='create-dsm5-teen/:formType'
											element={<CreateDsm5TeenPage />}
										/>
										<Route
											path='edit-dsm5-teen/:dsm5TeenId'
											element={<EditDsm5TeenPage />}
										/>
										<Route
											path='detail-dsm5-teen/:dsm5TeenId'
											element={<Dsm5TeenDetailPage />}
										/>
									</Route>
									<Route path='intervention/detail/:interventionId'>
										<Route index element={<InterventionDetailPage />} />
										<Route
											path='edit/:interventionPage'
											element={<EditCentreInterventionPage />}
										/>
										<Route
											path='edit-case-note/:interventionPage'
											element={<EditCaseNotePage />}
										/>
									</Route>
								</Route>
							</Route>
							<Route path='admission-request-list'>
								<Route index element={<AdmissionRequestAllSummaryPage />} />
								<Route
									path='not'
									element={<AdmissionRequestNotSummaryPage />}
								/>
								<Route path='detail/:admissionRequestId'>
									<Route index element={<AdmissionRequestDetail />} />
									<Route
										path='create/:myCaseId/:interventionPage'
										element={<CreateCentreInterventionPage />}
									/>
									<Route
										path='personal'
										element={
											<EditPersonalInformation type='admissionRequest' />
										}
									/>
									<Route
										path='contact'
										element={<EditContactInformation type='admissionRequest' />}
									/>
									<Route
										path='family'
										element={<EditFamilyInformation type='admissionRequest' />}
									/>
									<Route
										path='work'
										element={<EditWorkInformation type='admissionRequest' />}
									/>
									<Route
										path='membership'
										element={
											<EditMembershipInformation type='admissionRequest' />
										}
									/>
									<Route
										path='case'
										element={
											<EditCaseStatusInformation type='admissionRequest' />
										}
									/>
									<Route
										path='referrer'
										element={
											<EditReferrerInformation type='admissionRequest' />
										}
									/>
									<Route
										path='share'
										element={<EditShareInformation type='admissionRequest' />}
									/>
									<Route
										path='health'
										element={<EditHealthInformation type='admissionRequest' />}
									/>
									<Route path='forms-management'>
										<Route index element={<FormsManagementPage />} />
										<Route
											path='create-enquiry-record/:formType'
											element={<CreateEnquiryRecordPage />}
										/>
										<Route
											path='edit-enquiry-record/:enquiryRecordId'
											element={<EditEnquiryRecordPage />}
										/>
										<Route
											path='detail-enquiry-record/:enquiryRecordId'
											element={<EnquiryRecordDetailPage />}
										/>
										<Route
											path='create-face-sheet/:formType'
											element={<CreateFaceSheetPage />}
										/>
										<Route
											path='edit-face-sheet/:faceSheetId'
											element={<EditFaceSheetPage />}
										/>
										<Route
											path='detail-face-sheet/:faceSheetId'
											element={<FaceSheetDetailPage />}
										/>
										<Route
											path='create-appendix4/:formType'
											element={<CreateAppendix4Page />}
										/>
										<Route
											path='edit-appendix4/:appendix4Id'
											element={<EditAppendix4Page />}
										/>
										<Route
											path='detail-appendix4/:appendix4Id'
											element={<Appendix4DetailPage />}
										/>
										<Route
											path='create-appendix5/:formType'
											element={<CreateAppendix5Page />}
										/>
										<Route
											path='edit-appendix5/:appendix5Id'
											element={<EditAppendix5Page />}
										/>
										<Route
											path='detail-appendix5/:appendix5Id'
											element={<Appendix5DetailPage />}
										/>
										<Route
											path='create-appendix6/:formType'
											element={<CreateAppendix6Page />}
										/>
										<Route
											path='edit-appendix6/:appendix6Id'
											element={<EditAppendix6Page />}
										/>
										<Route
											path='detail-appendix6/:appendix6Id'
											element={<Appendix6DetailPage />}
										/>
										<Route
											path='create-appendix7/:formType'
											element={<CreateAppendix7Page />}
										/>
										<Route
											path='edit-appendix7/:appendix7Id'
											element={<EditAppendix7Page />}
										/>
										<Route
											path='detail-appendix7/:appendix7Id'
											element={<Appendix7DetailPage />}
										/>
										<Route
											path='create-member-application/:formType'
											element={<CreateMemberApplicationPage />}
										/>
										<Route
											path='edit-member-application/:memberApplicationId'
											element={<EditMemberApplicationPage />}
										/>
										<Route
											path='detail-member-application/:memberApplicationId'
											element={<MemberApplicationDetailPage />}
										/>
										<Route
											path='create-new-consent/:formType'
											element={<CreateNewConsentPage />}
										/>
										<Route
											path='edit-new-consent/:newConsentId'
											element={<EditNewConsentPage />}
										/>
										<Route
											path='detail-new-consent/:newConsentId'
											element={<NewConsentDetailPage />}
										/>
										<Route
											path='create-stop-service/:formType'
											element={<CreateStopServicePage />}
										/>
										<Route
											path='edit-stop-service/:stopServiceId'
											element={<EditStopServicePage />}
										/>
										<Route
											path='detail-stop-service/:stopServiceId'
											element={<StopServiceDetailPage />}
										/>
										<Route
											path='create-well-being-scale/:formType'
											element={<CreateWellBeingScalePage />}
										/>
										<Route
											path='edit-well-being-scale/:wellBeingScaleId'
											element={<EditWellBeingScalePage />}
										/>
										<Route
											path='detail-well-being-scale/:wellBeingScaleId'
											element={<WellBeingScaleDetailPage />}
										/>
										<Route
											path='create-recovery-assessment-scale/:formType'
											element={<CreateRecoveryAssessmentScalePage />}
										/>
										<Route
											path='edit-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<EditRecoveryAssessmentScalePage />}
										/>
										<Route
											path='detail-recovery-assessment-scale/:recoveryAssessmentScaleId'
											element={<RecoveryAssessmentScaleDetailPage />}
										/>
										<Route
											path='create-dsm5-adult/:formType'
											element={<CreateDsm5AdultPage />}
										/>
										<Route
											path='edit-dsm5-adult/:dsm5AdultId'
											element={<EditDsm5AdultPage />}
										/>
										<Route
											path='detail-dsm5-adult/:dsm5AdultId'
											element={<Dsm5AdultDetailPage />}
										/>
										<Route
											path='create-dsm5-teen/:formType'
											element={<CreateDsm5TeenPage />}
										/>
										<Route
											path='edit-dsm5-teen/:dsm5TeenId'
											element={<EditDsm5TeenPage />}
										/>
										<Route
											path='detail-dsm5-teen/:dsm5TeenId'
											element={<Dsm5TeenDetailPage />}
										/>
									</Route>
									<Route path='intervention/detail/:interventionId'>
										<Route index element={<InterventionDetailPage />} />
										<Route
											path='edit/:interventionPage'
											element={<EditCentreInterventionPage />}
										/>
										<Route
											path='edit-case-note/:interventionPage'
											element={<EditCaseNotePage />}
										/>
									</Route>
								</Route>
							</Route>
							<Route path='pending-submission-list'>
								<Route index element={<PendingSubmissionSummaryPage />} />
								<Route
									path='centre'
									element={<CentrePendingSubmissionSummaryPage />}
								/>
							</Route>
							<Route path='awaiting-list'>
								<Route index element={<AwaitingSummaryPage />} />
								<Route path='centre' element={<CentreAwaitingSummaryPage />} />
							</Route>
							<Route path='pending-intake-list'>
								<Route index element={<PendingIntakeSummaryPage />} />
								<Route
									path='centre'
									element={<CentrePendingIntakeSummaryPage />}
								/>
							</Route>
						</Route>
						<Route path='case-management'>
							<Route path='my-case'>
								<Route index element={<CaseAllSummaryPage />} />
								<Route path='pending' element={<CasePendingSummaryPage />} />
								<Route
									path='relieving'
									element={<CaseRelievingSummaryPage />}
								/>
								<Route path='shared' element={<CaseSharedSummaryPage />} />
								<Route
									path='create/:myCaseId/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
							<Route path='centre-case'>
								<Route index element={<CentreAdmittedSummaryPage />} />
								<Route
									path='not-admitted'
									element={<CentreNotAdmittedSummaryPage />}
								/>
								<Route path='close' element={<CentreCloseSummaryPage />} />
								<Route
									path='create/:myCaseId/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
							<Route path='my-program'>
								<Route index element={<ProgramAllSummaryPage />} />
								<Route path='pending' element={<ProgramPendingSummaryPage />} />
								<Route path='staff' element={<ProgramStaffSummaryPage />} />
								<Route
									path='create/:myCaseId/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
							<Route path='centre-program'>
								<Route index element={<CentreProgramSummaryPage />} />
								<Route
									path='not-admitted'
									element={<CentreProgramNotSummaryPage />}
								/>
								<Route
									path='create/:myCaseId/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
							<Route path='intervention'>
								<Route index element={<InterventionWorkerSummaryPage />} />
								<Route
									path='submitter'
									element={<InterventionSubmitterSummaryPage />}
								/>
								<Route path='detail/:interventionId'>
									<Route index element={<InterventionDetailPage />} />
									<Route
										path='edit/:interventionPage'
										element={<EditCentreInterventionPage />}
									/>
									<Route
										path='edit-case-note/:interventionPage'
										element={<EditCaseNotePage />}
									/>
								</Route>
								<Route
									path='create/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
							<Route path='centre-intervention'>
								<Route index element={<CentreInterventionSummaryPage />} />
								<Route path='detail/:interventionId'>
									<Route index element={<InterventionDetailPage />} />
									<Route
										path='edit/:interventionPage'
										element={<EditCentreInterventionPage />}
									/>
									<Route
										path='edit-case-note/:interventionPage'
										element={<EditCaseNotePage />}
									/>
								</Route>
								<Route
									path='create/:interventionPage'
									element={<CreateCentreInterventionPage />}
								/>
							</Route>
						</Route>
						<Route path='family-management'>
							<Route path='family-management-list'>
								<Route index element={<FamilyManagementSummaryPage />}></Route>
								<Route path='create' element={<FamilyCreatePage />} />
								<Route
									path='create/:familyUserId'
									element={<FamilyToCreatePage />}
								/>
								<Route path='detail/:familyId'>
									<Route index element={<FamilyDetailPage />}></Route>
									<Route
										path='edit-service-details'
										element={<FamilyEditServiceDetailsPage />}
									/>
									<Route
										path='edit-personal'
										element={<FamilyEditPersonalPage />}
									/>
									<Route
										path='edit-education'
										element={<FamilyEditEducationPage />}
									/>
									<Route
										path='edit-recovery'
										element={<FamilyEditRecoveryPage />}
									/>
									<Route
										path='edit-interests'
										element={<FamilyEditInterestsPage />}
									/>
									<Route
										path='edit-remarks'
										element={<FamilyEditRemarksPage />}
									/>
									<Route
										path='edit-login-id'
										element={<EditLoginIdPage entity='family-member' />}
									/>
									<Route
										path='edit-program-app-settings'
										element={<ProgramAppSettingsPage entity='family-member' />}
									/>
									<Route path='forms-management'>
										<Route
											index
											element={<FamilyFormsManagementPage />}
										></Route>
										<Route
											path='detail/:familyDetailFormId'
											element={<FamilyDetailZhPage />}
										/>
									</Route>
								</Route>
							</Route>
						</Route>
						<Route path='field-management'>
							<Route path='field-management-list'>
								<Route index element={<FieldManagementSummaryPage />}></Route>
								<Route path='unit/:fieldId'>
									<Route index element={<UnitSummaryPage />}></Route>
									<Route path='status' element={<UnitStatusPage />} />
									<Route path='order' element={<UnitOrderPage />} />
								</Route>
								<Route path='region/:fieldId'>
									<Route index element={<RegionSummaryPage />}></Route>
									<Route path='status' element={<RegionStatusPage />} />
									<Route path='order' element={<RegionOrderPage />} />
									<Route path='district/:districtId'>
										<Route
											index
											element={<RegionSummaryPage title='District' type={1} />}
										></Route>
										<Route
											path='status'
											element={<RegionStatusPage type={1} />}
										/>
										<Route
											path='order'
											element={<RegionOrderPage type={1} />}
										/>
										<Route path='sub-district/:subDistrictId'>
											<Route
												index
												element={
													<RegionSummaryPage title='Sub-district' type={2} />
												}
											></Route>
											<Route
												path='status'
												element={<RegionStatusPage type={2} />}
											/>
											<Route
												path='order'
												element={<RegionOrderPage type={2} />}
											/>
											<Route path='ecv/:ecvId'>
												<Route
													index
													element={
														<RegionSummaryPage
															title='Estate / Court / Village'
															type={3}
														/>
													}
												></Route>
												<Route
													path='status'
													element={<RegionStatusPage type={3} />}
												/>
												<Route
													path='order'
													element={<RegionOrderPage type={3} />}
												/>
												<Route path='build/:buildId'>
													<Route
														index
														element={
															<RegionSummaryPage
																title='Building / Block'
																type={4}
															/>
														}
													></Route>
													<Route
														path='status'
														element={<RegionStatusPage type={4} />}
													/>
													<Route
														path='order'
														element={<RegionOrderPage type={4} />}
													/>
												</Route>
											</Route>
										</Route>
									</Route>
								</Route>
								<Route path='field/:fieldId/:fieldType'>
									<Route
										index
										element={<FieldCommonSummaryPage type={1} />}
									></Route>
									<Route
										path='status'
										element={<FieldCommonStatusPage type={1} />}
									/>
									<Route
										path='order'
										element={<FieldCommonOrderPage type={1} />}
									/>
									<Route path='agency/:agencyId/:agencyType'>
										<Route
											index
											element={<FieldCommonSummaryPage type={2} />}
										></Route>
										<Route
											path='status'
											element={<FieldCommonStatusPage type={2} />}
										/>
										<Route
											path='order'
											element={<FieldCommonOrderPage type={2} />}
										/>
										<Route path='referral/:referralId/:referralType'>
											<Route
												index
												element={<FieldCommonSummaryPage type={3} />}
											></Route>
											<Route
												path='status'
												element={<FieldCommonStatusPage type={3} />}
											/>
											<Route
												path='order'
												element={<FieldCommonOrderPage type={3} />}
											/>
										</Route>
									</Route>
									<Route path='diagnosis/:diagnosisId/:diagnosisType'>
										<Route
											index
											element={<FieldCommonSummaryPage type={4} />}
										></Route>
										<Route
											path='status'
											element={<FieldCommonStatusPage type={4} />}
										/>
										<Route
											path='order'
											element={<FieldCommonOrderPage type={4} />}
										/>
									</Route>
								</Route>
							</Route>
						</Route>
						<Route path='report-summary' element={<ReportSummaryPage />} />
						<Route path='notifications'>
							<Route index element={<NotificationSummaryPage />} />
							<Route
								path='detail/:notificationId'
								element={<NotificationDetailPage />}
							/>
						</Route>
					</Route>
				</Route>
			</Route>
		</>
	)
);

export default router;
